import { Sentry } from '@/observability/sentry'
import '@/observability/posthog'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { Toaster } from 'sonner'
import '../styles/global.css'
import App from './App'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <Sentry.ErrorBoundary fallback={<p>Ocurrió un error inesperado.</p>}>
        <App />
        <Toaster position="top-right" richColors closeButton />
      </Sentry.ErrorBoundary>
    </HelmetProvider>
  </StrictMode>,
)
